quoteModule.factory("LenderInfo", function() {
    var LenderInfo = function(){
        this.lenderId = 0;
        this.code = "";
        this.name = "";
        this.address1 = "";
        this.address2 = "";
        this.city = "";
        this.state = "";
        this.zip = "";
        this.phone = "";
        this.spanDealerId = "";
        this.isDefault = false;
        this.providerMandatoryLenderId = 0;
        this.lenderProviderCode = "";
    }

    //validation of deal data for saving a quote.. not much here because we really don't
    // require deal data to save a quote
    LenderInfo.prototype.dataReadyToSaveQuote = function() {
        var dataReady = true;
        dataReady = this.name && this.name.length > 0;

        return dataReady;
    }
    LenderInfo.prototype.consumeFromRateQuoteRetrieve = function(partnerSpecificFields) {
        var keys = partnerSpecificFields.map(function(ele) { return ele.key; });
        var values = partnerSpecificFields.map(function(ele) { return ele.value; });

        this.code = values[keys.indexOf('LenderCode')];
        this.name = values[keys.indexOf('LenderName')];
        this.address1 = values[keys.indexOf('LenderAddress1')];
        this.address2 = values[keys.indexOf('LenderAddress2')];
        this.city = values[keys.indexOf('LenderCity')];
        this.state = values[keys.indexOf('LenderState')];
        this.zip = values[keys.indexOf('LenderZip')];
        this.email = values[keys.indexOf('LenderEmail')];
        this.phone = values[keys.indexOf('LenderPhone')];
        this.providerSpecificCode = keys.indexOf('LenderProviderCode') >= 0 ? values[keys.indexOf('LenderProviderCode')] : '';
    }
    
    LenderInfo.prototype.populateFromTlcApi = function(data) {
        this.Id = data.lenderId;
        this.name = data.name;
        this.code = data.abbreviation;
        this.address1 = data.addressLine1;
        this.address2 = data.addressLine2;
        this.city = data.city;
        this.state = data.state;
        this.zip = data.zipCode !=null || data.zipCode != undefined ? data.zipCode.replace('-','') : '';
        this.phone = data.phone;
        this.spanDealerId = data.spanDealerId;
        this.isDefault = data.isDefault;
        this.providerMandatoryLenderId = data.providerMandatoryLenderId;
        this.providerSpecificCode = data.providerSpecificCode;
    };

    LenderInfo.prototype.convertForTlcApi = function() {
        var result = {
            lenderId: this.Id,
            name: this.name,
            abbreviation: this.code,
            addressLine1: this.address1,
            addressLine2: this.address2,
            city: this.city,
            state: this.state,
            zipCode: this.zip,
            phone: this.phone,
            spanDealerId: this.spanDealerId,
            isDefault: this.isDefault,
            providerMandatoryLenderId: this.providerMandatoryLenderId || null,
            providerSpecificCode: this.providerSpecificCode || null
        };
        return result;
    };
    return LenderInfo;
});

